import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15afb64a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mt-2 mb-2" }
const _hoisted_7 = { class: "modal-footer row" }
const _hoisted_8 = {
  key: 0,
  class: "col-8 col-sm-4 col-md-3 col-lg-5"
}
const _hoisted_9 = {
  key: 1,
  class: "col-12 d-flex gap-2 justify-content-center mt-3"
}
const _hoisted_10 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-container align-items-center mb-3",
        style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
      }, [
        (!_ctx.keyAccountConsent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_ctx.hideClose || !_ctx.keyAccountConsent)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                    "aria-label": "Close"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-header mt-3", {'consent-modal-header justify-content-center' : _ctx.keyAccountConsent}])
        }, [
          (_ctx.message)
            ? _renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
                _createVNode(_component_AsahiTypography, {
                  type: "title-1-bold",
                  class: _normalizeClass({'text-uppercase' : _ctx.keyAccountConsent})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.message)), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ], true)
            : _createCommentVNode("", true),
          (_ctx.messagehtml)
            ? _renderSlot(_ctx.$slots, "header", { key: 1 }, () => [
                _createElementVNode("h5", {
                  innerHTML: _ctx.messagehtml,
                  class: "message-text"
                }, null, 8, _hoisted_4)
              ], true)
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", null, [
          _createVNode(_component_AsahiTypography, { type: "title-2-regular" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.headerSubMsg)), 1)
            ]),
            _: 1
          }),
          (_ctx.hyperLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.hyperLink,
                target: "_self",
                color: "tertiary"
              }, _toDisplayString(_ctx.hyperLinkText), 9, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-body", {'text-left' : _ctx.keyAccountConsent}])
        }, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _createVNode(_component_AsahiTypography, { type: "subtitle" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.subMessage)), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_AsahiTypography, { type: "subtitle-3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.addSubMessage)), 1)
                ]),
                _: 1
              })
            ])
          ], true)
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            (!_ctx.keyAccountConsent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.showButton)
                    ? (_openBlock(), _createBlock(_component_AsahiButton, {
                        key: 0,
                        type: "primary",
                        class: "w-100",
                        onClick: _ctx.close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.buttonText)), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.showButton)
                    ? (_openBlock(), _createBlock(_component_AsahiButton, {
                        key: 0,
                        type: "primary",
                        onClick: _ctx.skip
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('SKIP FOR NOW')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.showButton)
                    ? (_openBlock(), _createBlock(_component_AsahiButton, {
                        key: 1,
                        type: "primary",
                        onClick: _ctx.close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('GO BACK TO GIVE CONSENT')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_AsahiTypography, { type: "subtitle" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.footerMessage)), 1)
                ]),
                _: 1
              })
            ])
          ], true)
        ])
      ], 4)
    ])
  ]))
}